// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1qW9R","rootCenter":"LoadMoreObserver_rootCenter__18IzY","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1pzO-"};